type PdfPageSkeletonProps = {
  width?: number;
  height?: number;
};

export function PdfPageSkeleton({ width = 595, height = 842 }: PdfPageSkeletonProps) {
  const pad = Math.round(width * 0.09);
  const inner = width - pad * 2;
  const lineH = Math.max(8, Math.round(height * 0.014));
  const rowGap = Math.max(6, Math.round(height * 0.009));
  const blockGap = Math.round(height * 0.05);
  const imgH = Math.round(height * 0.22);
  const titleH = Math.max(14, Math.round(height * 0.024));

  const para = (widths: number[], key: number) => (
    <div key={key} className="flex flex-col" style={{ gap: rowGap }}>
      {widths.map((w, i) => (
        <div
          key={i}
          className="rounded-sm bg-neutral-200"
          style={{ width: Math.round(inner * w), height: lineH }}
        />
      ))}
    </div>
  );

  return (
    <div
      className="animate-pulse bg-white shadow-sm flex-shrink-0"
      style={{ width, height, padding: pad }}
    >
      {/* Title */}
      <div
        className="rounded-sm bg-neutral-300"
        style={{ width: Math.round(inner * 0.52), height: titleH, marginBottom: blockGap }}
      />

      {/* Paragraph 1 */}
      {para([1, 0.93, 0.86, 1, 0.71], 0)}

      {/* Image block */}
      <div
        className="rounded bg-neutral-200"
        style={{ width: inner, height: imgH, marginTop: blockGap, marginBottom: blockGap }}
      />

      {/* Paragraph 2 */}
      {para([1, 0.9, 0.84, 1, 0.62], 1)}

      <div style={{ height: blockGap }} />

      {/* Paragraph 3 */}
      {para([1, 0.87, 0.75], 2)}
    </div>
  );
}
